<template>
  <section class="page-section statistics">
    <transition v-if="viewState.isLoadingStatistics" name="fade" mode="out-in">
      <WaitingBlock></WaitingBlock>
    </transition>
    <ErrorPage v-else-if="statistics==null">
      <template slot="Title">Something is missing!</template>
      <template slot="SubTitle">No statistic has been loaded for this clock</template>
      <template slot="Content">
        <div class="helper-container">
          <RequiredActionItem>
            <template>
              <span>
                Check if you have any
                <a
                  href="#"
                  @click="$router.push({name:'ClockDetails', params:$route.params});"
                >box</a> in your clock.
              </span>
            </template>
          </RequiredActionItem>
        </div>
      </template>
      <template slot="Actions">
        <Button
          :empty="true"
          @click="$router.push({name:'ClockDetails', params:$route.params});"
        >Back to clock boxes</Button>
      </template>
    </ErrorPage>
    <div v-else>
      <div class="highlights">
        <StatisticHighlight v-for="highlight in highlights" :key="highlight.id" :statistic="highlight"></StatisticHighlight>
      </div>
      <div class="item-list">
        <table class="table">
          <thead>
            <tr>
              <th>Box</th>
              <th># Tracks</th>
              <th>Duration</th>
              <th>Avg duration</th>
              <th># Occurences</th>
              <th>% Occurences</th>
              <th>Per Hour</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="box in statistics.boxStatistics" :key="box.uid">
              <th>{{box.boxName}}</th>
              <td>{{box.trackCount}}</td>
              <td>{{decimalMinToMoment(box.playDuration)}}</td>
              <td>{{decimalMinToMoment(box.averageTrackDuration)}}</td>
              <td>{{box.occurences}}</td>
              <td>{{(box.ratio *100.00).toFixed(2)}} %</td>
              <td>{{decimalMinToMoment(box.durationPerHour)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import WaitingBlock from "@/components/common/WaitingBlock.vue";
import StatisticHighlight from "@/components/common/StatisticHighlight";
import RequiredActionItem from "@/components/common/RequiredActionItem";
import { mapState, mapActions } from "vuex";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import ErrorPage from "@/components/common/ErrorPage.vue";
import Moment from "moment";
export default {
  name: "ClockStatCard",
  components: {
    StatisticHighlight,
    ErrorPage,
    RequiredActionItem,
    WaitingBlock
  },
  mounted() {
    this.loadStatistics();
  },
  watch: {
    "$route.params": function() {
      this.loadStatistics();
    }
  },
  computed: {
    ...mapState(["currentClock", "isLoadingClock"]),
    Moment: () => Moment,
    highlights() {
      if (!this.currentClock || !this.currentClock.statistics) return [];
      let highLightList = [];

      highLightList.push({
        label: "# Boxes",
        value: this.statistics.boxCount,
        unit: null
      });
      highLightList.push({
        label: "# Boxes(distinct)",
        value: this.statistics.distinctBoxCount,
        unit: null
      });
      highLightList.push({
        label: "Cycle per hour",
        value: (this.statistics.hourCycleCount || 0).toFixed(2),
        unit: null
      });
      highLightList.push({
        label: "Cycle Time",
        value: this.decimalMinToMoment(this.statistics.cycleDuration),
        unit: null
      });

      return highLightList;
    }
  },
  data() {
    return {
      viewState: {
        isLoadingStatistics: false
      },
      statistics: null
    };
  },
  methods: {
    async loadStatistics() {
      this.viewState.isLoadingStatistics = true;
      this.statistics = null;
      try {
        console.log(Apis.clocks.stats, this.$route.params);
        let response = await HTTP.get(Apis.clocks.stats, {
          params: this.$route.params
        });
        console.log("---->", response);
        this.statistics = response.data.dataItem;
      } catch (exception) {
        alert("An error occured");
        console.log(exception);
      } finally {
        this.viewState.isLoadingStatistics = false;
      }
    },

  }
};
</script>

<style lang="scss" scoped>
section.statistics {
  margin: auto;
  .highlights {
    display: flex;
    width: 100%;
    border: 1px solid var(--COLOR_BORDERS);
    .highlight {
      width: 100%;
      flex-grow: 1;
      margin: auto;
      border-right:1px solid var(--COLOR_BORDERS)
    }
  }
  .item-list {
    overflow: auto;
    table {
      th,
      td {
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 15px;
      }
      th:first-child {
        left: 0;
        text-align: left;
        background: white;

        &:first-child {
          width: 100%;
        }
      }
    }
  }
}
</style>